<div #overviewMapArea class="overview-map"></div>